import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';

import SavedCards from './SavedCards';
import Reviews from './review';
import College from './College';
import Usercode from './Usercode';
import BundleNo from './BundleNo';
import Ipnumber from './BundleNo';
import Bundlekey from './Bundlekey';
import OmrCodes from './OmrCodes';

import Message from './MarkSaving';
import MarksTable from './MarksTable';
import GrandtotalMarks from './CheckTotalMarks';
import scriptPath from './ScriptPdf';
import userRegister from './UserRegister';
import valuatorCode from './UserRegister';
import userToken from './UserTokenRegister';
import CrystalPdf from './CrystalPdf';
import IpAddress from './ValuatorLoginSaving';
import AutoSave from './MarkSaving';
import Designation from './Designation'
export default (history) => combineReducers({
  router: connectRouter(history),
  savedCards: SavedCards,
  Reviews :Reviews,
  College: College,
  Usercode:Usercode,
  BundleNo:BundleNo,
  Ipnumber:Ipnumber,
  Bundlekey:Bundlekey,
  OmrCodes:OmrCodes,
  MarksTable:MarksTable,
  Message:Message,
  GrandtotalMarks:GrandtotalMarks,
  scriptPath:scriptPath,
  userRegister:userRegister,
  userToken:userToken,
  CrystalPdf:CrystalPdf,
  IpAddress:IpAddress,
  AutoSave:AutoSave,
  valuatorCode:valuatorCode,
  Designation:Designation
});
